
































import { Component, Prop, Vue } from 'vue-property-decorator';
import AuthenticatedNav from '@classes/AuthenticatedNav';
import { HeaderStyle } from 'types/header';
import { investmentEntity } from '@store/modules/investment-entity';
import { InvestmentEntity } from 'types/investment-entity';
import { Link } from 'types/layout';
import MobileNavTemplate from '@components/header/navigation/mobile/mobile-nav-template.vue';
import NavDropdownHeader from '../nav-dropdown-header.vue';
import NavigationLinkMobile from '@components/header/navigation/mobile/navigation-link-mobile.vue';
import NavInvestmentEntityList from '../nav-investment-entity-list.vue';
import { settingsLinks } from '../links';
import { user } from '@store/modules/user';

@Component({
	components: {
		MobileNavTemplate,
		NavDropdownHeader,
		NavigationLinkMobile,
		NavInvestmentEntityList
	}
})
export default class MobileNavAuth extends Vue {
	@Prop()
	private styles!: HeaderStyle;

	get investmentEntityObject(): InvestmentEntity {
		return investmentEntity.investmentEntityObject;
	}

	settingsLinks: Array<Link> = settingsLinks;

	get nav(): AuthenticatedNav {
		return new AuthenticatedNav(user.user, investmentEntity.investmentEntityObject);
	}
}
